import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromWorkbook from '@workbook/store/workbook.reducer';
import { Workbook } from '@models';

export const getWorkbooksState = createFeatureSelector(fromWorkbook.workbookFeatureKey);
export const getCollection = createSelector(getWorkbooksState, (state: fromWorkbook.WorkbookState) => state.collection);
// export const getModuleParams = (moduleName: string) => createSelector(getWorkbooksState,
//   (state: fromWorkbook.WorkbookState) => state.collection.find((m: Workbook) => m.module_name === moduleName)
// );

export const fetchingCollection = createSelector(getWorkbooksState, (state: fromWorkbook.WorkbookState) => state.isFetching);

export const getRow = createSelector(getWorkbooksState, (state: fromWorkbook.WorkbookState) => {
  return state.row;
});

export const defaultView = createSelector(getWorkbooksState, (state: fromWorkbook.WorkbookState) => {
  return {view: state.defaultView, isFetching: state.isFetching};
});

export const successfullyApplied = createSelector(
  getWorkbooksState, (state: fromWorkbook.WorkbookState) => (
    {successfullyApplied: state.successfullyApplied})
);

export const getError = createSelector(
  getWorkbooksState,
  (state: fromWorkbook.WorkbookState) => {
    return {error: state.error, errorType: state.errorType};
  }
);
